import styled from 'styled-components6';

// Using div elements instead of h1-h6 to prevent style inheritance from parent sites
// The .rwl-text-* classes provide all the correct typography styling
export const H1 = styled.div.attrs({ className: 'rwl-text-h1' })`
    color: var(--rwl-text-default);
    margin: 0;
`;
export const H2 = styled.div.attrs({ className: 'rwl-text-h2' })`
    color: var(--rwl-text-default);
    margin: 0;
`;
export const H3 = styled.div.attrs({ className: 'rwl-text-h3' })`
    color: var(--rwl-text-default);
    margin: 0;
`;
export const H4 = styled.div.attrs({ className: 'rwl-text-h4' })`
    color: var(--rwl-text-default);
    margin: 0;
`;
export const H5 = styled.div.attrs({ className: 'rwl-text-h5' })`
    color: var(--rwl-text-default);
    margin: 0;
`;
export const H6 = styled.div.attrs({ className: 'rwl-text-h6' })`
    color: var(--rwl-text-default);
    margin: 0;
`;

export const Subtitle1 = styled.div.attrs({
    className: 'rwl-text-subtitle1',
})`
    color: var(--rwl-text-default);
`;
export const Subtitle2 = styled.div.attrs({
    className: 'rwl-text-subtitle2',
})`
    color: var(--rwl-text-default);
`;
export const Body1 = styled.div.attrs({ className: 'rwl-text-body1' })`
    color: var(--rwl-text-default);
`;
export const Body2 = styled.div.attrs({ className: 'rwl-text-body2' })`
    color: var(--rwl-text-hint);
`;
export const Chip = styled.div.attrs({ className: 'rwl-text-chip' })`
    color: var(--rwl-text-hint);
`;
export const Button = styled.div.attrs({ className: 'rwl-text-button' })`
    color: var(--rwl-text-default);
`;

export const Caption1 = styled.div.attrs({ className: 'rwl-text-caption1' })`
    color: var(--rwl-text-default);
`;
export const Caption2 = styled.div.attrs({ className: 'rwl-text-caption2' })`
    color: var(--rwl-text-hint);
`;
export const Overline = styled.div.attrs({ className: 'rwl-text-overline' })`
    color: var(--rwl-text-default);
`;
